module.exports = __webpack_public_path__ + "img/happyface.6bdad019.svg";